'use client';

import { motion, useScroll, useSpring } from 'framer-motion';

/**
 * Thin ochre line at the top of the viewport showing scroll progress.
 * Hidden when prefers-reduced-motion is on (CSS handles it).
 */
export function ScrollProgressBar() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 24,
    mass: 0.2,
  });

  return (
    <motion.div
      aria-hidden
      style={{ scaleX, transformOrigin: '0% 50%' }}
      className="pointer-events-none fixed inset-x-0 top-0 z-[60] h-[2px] bg-gradient-ochre"
    />
  );
}
